<script>
  // Small rounded avatar/thumbnail. `value` is the image URL. Optionally pairs with
  // a label from `column.labelField` (dot-path) for an avatar + name cell.
  //
  // `column.lightbox`: the avatar opens the lightbox and only the label links to the
  // row (entity_slot passes `href` instead of wrapping the cell). When the page passes
  // `onImageEdit(row)`, the lightbox offers "Change picture" and a missing avatar
  // becomes an upload button.
  import { Link } from '@inertiajs/svelte'
  import { resolveField } from '../../../lib/entities/slots.js'
  import ClickableImage from '../../lightbox/clickable_image.svelte'
  import UserAvatar from '../../user_avatar.svelte'
  import Button from '../../ui/button.svelte'
  import Icon from '../../ui/icon.svelte'

  let { value, row = {}, column = {}, href = null, onImageEdit = null } = $props()
  const label = $derived(column.labelField ? resolveField(row, column.labelField) : null)
  let failed = $state(false)
</script>

{#if column.lightbox}
  <div class="flex items-center gap-2">
    {#if value}
      <ClickableImage url={value} title={label || ''} thumbClass="w-8 h-8 rounded-full object-cover" buttonClass="shrink-0 rounded-full">
        {#snippet actions(close)}
          {#if onImageEdit}
            <Button variant="default" size="sm" icon="edit" onclick={() => { close(); onImageEdit(row) }}>Change picture</Button>
          {/if}
        {/snippet}
      </ClickableImage>
    {:else}
      <UserAvatar size="sm" name={label} title={onImageEdit ? 'Upload profile picture' : undefined} onclick={onImageEdit ? () => onImageEdit(row) : undefined} />
    {/if}
    {#if label}
      {#if href}
        <Link {href} class="truncate hover:underline">{label}</Link>
      {:else}
        <span class="truncate">{label}</span>
      {/if}
    {/if}
  </div>
{:else}
  <div class="flex items-center gap-2">
    <div class="avatar">
      <div class="w-8 h-8 rounded-full bg-base-200 flex items-center justify-center overflow-hidden">
        {#if value && !failed}
          <img src={value} alt={label || ''} class="w-full h-full object-cover" onerror={() => (failed = true)} />
        {:else}
          <Icon name="users" size="sm" class="text-base-content/40" />
        {/if}
      </div>
    </div>
    {#if label}<span class="truncate">{label}</span>{/if}
  </div>
{/if}
